// Alerts
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Breadcrumb
export const EDITAR_BREADCRUMB = 'EDITAR_BREADCRUMB';

// Loader
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

// Auth
export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const OBTENER_USUARIO_ERROR = 'OBTENER_USUARIO_ERROR';
export const LOGOUT = 'LOGOUT';
export const RECUPERAR_USUARIO = 'RECUPERAR_USUARIO';
export const RESTABLECER_USUARIO = 'RESTABLECER_USUARIO';

// Dashboard
export const DASHBOARD = {
    OBTENER: 'OBTENER_DASHBOARD'
};

// Sucursales
export const SUCURSALES = {
    BUSCAR:      'BUSCAR_SUCURSALES',
    AGREGAR:     'AGREGAR_SUCURSAL',
    EDITAR:      'EDITAR_SUCURSAL',
    ELIMINAR:    'ELIMINAR_SUCURSAL',
    DETALLES:    'DETALLES_SUCURSAL',
    INFORMACION: 'INFORMACION_SUCURSAL',
    LIMPIAR:     'LIMPIAR_SUCURSAL'
};

// Empleados
export const EMPLEADOS = {
    BUSCAR:   'BUSCAR_EMPLEADOS',
    AGREGAR:  'AGREGAR_EMPLEADO',
    EDITAR:   'EDITAR_EMPLEADO',
    ELIMINAR: 'ELIMINAR_EMPLEADO',
    DETALLES: 'DETALLES_EMPLEADO',
    PERFIL:   'PERFIL_EMPLEADO',
    LIMPIAR:  'LIMPIAR_EMPLEADO'
};

// Proveedores
export const PROVEEDORES = {
    BUSCAR:   'BUSCAR_PROVEEDORES',
    AGREGAR:  'AGREGAR_PROVEEDOR',
    EDITAR:   'EDITAR_PROVEEDOR',
    ELIMINAR: 'ELIMINAR_PROVEEDOR',
    DETALLES: 'DETALLES_PROVEEDOR',
    PERFIL:   'PERFIL_PROVEEDOR',
    LIMPIAR:  'LIMPIAR_PROVEEDOR'
};

// Gastos
export const GASTOS = {
    BUSCAR:           'BUSCAR_GASTOS',
    AGREGAR:          'AGREGAR_GASTO',
    AGREGAR_MULTIPLE: 'AGREGAR_GASTOS_MULTIPLE',
    EDITAR:           'EDITAR_GASTO',
    ELIMINAR:         'ELIMINAR_GASTO',
    DETALLES:         'DETALLES_GASTO',
    LIMPIAR:          'LIMPIAR_GASTO'
};

// Eventos
export const EVENTOS = {
    BUSCAR:      'BUSCAR_EVENTOS',
    AGREGAR:     'AGREGAR_EVENTO',
    EDITAR:      'EDITAR_EVENTO',
    ELIMINAR:    'ELIMINAR_EVENTO',
    DETALLES:    'DETALLES_EVENTO',
    INFORMACION: 'INFORMACION_EVENTO',
    LIMPIAR:     'LIMPIAR_EVENTO'
};

// Usuarios
export const USUARIO = {
    BUSCAR: 'BUSCAR_USUARIOS',
    AGREGAR: 'AGREGAR_USUARIO',
    DETALLES: 'DETALLES_USUARIO',
    EDITAR: 'EDITAR_USUARIO',
    ELIMINAR: 'ELIMINAR_USUARIO',
    FILTROS: 'FILTRAR_USUARIOS',
    LIMPIAR: 'LIMPIAR_USUARIO'
};

// Ventas
export const VENTAS = {
    BUSCAR:      'BUSCAR_VENTAS',
    INFORMACION: 'INFORMACION_VENTA',
    LIMPIAR:     'LIMPIAR_VENTA'
};

// Nóminas
export const NOMINAS = {
    BUSCAR:   'BUSCAR_NOMINAS',
    DETALLES: 'DETALLES_NOMINA',
    AGREGAR:  'AGREGAR_NOMINA',
    EDITAR:   'EDITAR_NOMINA',
    LIMPIAR:  'LIMPIAR_NOMINA'
};

// Revisiones
export const REVISIONES = {
    BUSCAR:      'BUSCAR_REVISIONES',
    INFORMACION: 'INFORMACION_REVISION',
    CONFIRMAR:   'CONFIRMAR_REVISION',
    LIMPIAR:     'LIMPIAR_REVISION'
};

// Vueltas
export const VUELTAS = {
    BUSCAR:      'BUSCAR_VUELTAS',
    INFORMACION: 'INFORMACION_VUELTA',
    LIMPIAR:     'LIMPIAR_VUELTA'
};

// Cortes de caja
export const CORTES = {
    BUSCAR:      'BUSCAR_CORTES',
    INFORMACION: 'INFORMACION_CORTE',
    LIMPIAR:     'LIMPIAR_CORTE'
};

// Pagos de vueltas
export const PAGOS = {
    BUSCAR:      'BUSCAR_PAGOS',
    INFORMACION: 'INFORMACION_PAGO',
    LIMPIAR:     'LIMPIAR_PAGO'
};

// Metodos de pago
export const METODOS = {
    BUSCAR: 'BUSCAR_METODOS'
};

// Configuración
export const PERFIL = {
    EDITAR: 'EDITAR_PERFIL'
};

export const CONFIGURACION = {
    METODOS: {
        BUSCAR:   'BUSCAR_CONFIGURACION_METODOS',
        AGREGAR:  'AGREGAR_CONFIGURACION_METODO',
        EDITAR:   'EDITAR_CONFIGURACION_METODO',
        ELIMINAR: 'ELIMINAR_CONFIGURACION_METODO',
        DETALLES: 'DETALLES_CONFIGURACION_METODO',
        LIMPIAR:  'LIMPIAR_CONFIGURACION_METODO'
    },
    PRODUCTOS: {
        BUSCAR:   'BUSCAR_CONFIGURACION_PRODUCTOS',
        AGREGAR:  'AGREGAR_CONFIGURACION_PRODUCTO',
        EDITAR:   'EDITAR_CONFIGURACION_PRODUCTO',
        ELIMINAR: 'ELIMINAR_CONFIGURACION_PRODUCTO',
        DETALLES: 'DETALLES_CONFIGURACION_PRODUCTO',
        LIMPIAR:  'LIMPIAR_CONFIGURACION_PRODUCTO'
    }
};